import React from 'react';
import DataCorrelationInfoBox from './DataCorrelationInfoBox';
import DataCorrelationGraph from './DataCorrelationGraph';

/**
 * @typedef {object} DataCorrelationItemProps
 * @property {Object} reportData
 * @property {Object} [selectedClassificationMetric]
 * @property {Object} [selectedPracticeArea]
 */

/**
 * @param {DataCorrelationItemProps} props
 */
const DataCorrelationItem = props => {
  const { reportData, selectedClassificationMetric, selectedPracticeArea } = props;

  return (
    <div
      className='data-correlation-graph-container'
      data-testid='data-correlation-graph-container'>
      <DataCorrelationInfoBox
        metricCalculationName={reportData.metricCalculationName}
        classificationMetric={selectedClassificationMetric || {}}
        practiceAreaInfo={reportData.practiceInfo}
        practiceDescription={reportData.practiceDescription}
      />
      <div className='data-correlation-graph'>
        <DataCorrelationGraph
          data={reportData.quarterlyAverages}
          practiceLabel={`${selectedPracticeArea?.Name} (${reportData.practiceInfo})`}
          metricLabel={selectedClassificationMetric?.classificationMetricName}
          metricCalculationType={selectedClassificationMetric?.classificationCalculationType}
        />
      </div>
    </div>
  );
};

export default DataCorrelationItem;
